import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings/setup-checklist')({
  // Component lazy loaded from setup-checklist.lazy.tsx
});
